import { z } from "zod";
import { ExtractionConfidence, ParsingType } from "../interfaces/doc";

const CustomSchemaFieldResultSchema = z
  .object({
    name: z.string(),
    parsing_type: z.enum([
      ParsingType.Date,
      ParsingType.Float,
      ParsingType.Int,
      ParsingType.String,
      ParsingType.Boolean,
      ParsingType.Enum,
      ParsingType.Custom,
    ]),
    enum_values: z.string().array().min(2).optional().nullable(),
  })
  .refine(
    (custom_field) =>
      custom_field.parsing_type === ParsingType.Enum
        ? !!custom_field.enum_values
        : !custom_field.enum_values,
    {
      message:
        "Enum values must be provided if and only if parsing type is Enum",
    }
  );

export const AddressSchema = z.object({
  number: z.string().nullable().optional(),
  way: z.string().nullable().optional(),
  postal_code: z.string().nullable().optional(),
  city: z.string().nullable().optional(),
  country: z.string().nullable(),
});

export const NameSchema = z.object({
  civility: z.string().nullable().optional(),
  firstname: z.string().nullable().optional(),
  lastname: z.string().nullable().optional(),
});

export const CurrencySchema = z.object({
  value: z.number().nullable().optional(),
  currency: z.string().nullable().optional(),
});

export const MeasureSchema = z.object({
  value: z.number().nullable().optional(),
  unit: z.string().nullable().optional(),
});

export const ExtractionSourceSchema = z.object({
  value: z.string(),
  page: z.number().nullable().optional(),
  position: z.tuple([z.number(), z.number()]).nullable().optional(),
});

export const ExtractionResultBaseSchema = z.object({
  name: z.string(),
  enum_values: z.string().array().min(2).nullable(),
  confidence: z.nativeEnum(ExtractionConfidence).nullable().optional(),
  custom_schema: CustomSchemaFieldResultSchema.array()
    .nullable()
    .refine(
      (custom_schema) =>
        !custom_schema ||
        custom_schema.map(
          (custom_field) => custom_field.parsing_type !== ParsingType.Custom
        ),
      { message: "Can't define nested custom schema" }
    ),
  expected_value: z.any().nullable(),
  check: z.boolean().nullable(),
  parsing_type: z.nativeEnum(ParsingType),
  source: ExtractionSourceSchema.nullable().optional(),
});
